import React, { useContext, useEffect } from "react";
import { MenuItem, Select, Typography } from "@mui/material";
import { GeographyContext } from "GeographyContextWrapper";
import { stateLabelMappings } from "models/Geography";
import { LeadContext } from "LeadContextWrapper";

interface IProps {
  initialCountryId?: number,
  initialStateId?: number,
}

export function CountryStateSelection(props:IProps):JSX.Element {
  const { countries, states } = React.useContext(GeographyContext)
  const [selectedCountryId, setSelectedCountryId] = React.useState<number>(-1)
  const [selectedStateId, setSelectedStateId] = React.useState<number>(-1)
  const [stateOrProvince, setStateOrProvince] = React.useState<string>("")
  const { lead, saveLeadData } = useContext(LeadContext)

  useEffect(() => {
    if(countries) {
      const foundCountry = countries.find(c => {
        return c.id === selectedCountryId
    })
      if(foundCountry) {
        setStateOrProvince(stateLabelMappings[foundCountry.slug])
        return
      } 
    }

    setStateOrProvince("")
  }, [selectedCountryId])

  useEffect(() => {
    props.initialCountryId && setSelectedCountryId(props.initialCountryId)
    props.initialStateId && setSelectedStateId(props.initialStateId)
  }, [])

  return <>
    <Typography variant="h3">What country and state is the estate located in?</Typography>
    <Typography variant="body1" component={"div"} style={{paddingTop:"2rem"}}>
      <Select
        key={"countrySelection"}
        style={{minWidth:"400px", marginRight:"1rem"}}
        disabled={!lead?.key || !saveLeadData}
        value={selectedCountryId}
        onChange={async e => {
          if(!lead?.key || !saveLeadData) {
            console.warn("not ready to save lead yet")
            return
          }

          const countryId = Number.parseInt(e.target.value.toString())
          setSelectedCountryId(countryId)
          if(selectedCountryId.toString() != countryId.toString()) {
            setSelectedStateId(-1)
            return
          }
          
          await saveLeadData(lead.key, {
            "country_id": countryId,
            "state_id": selectedStateId,
          })
        }}
      >
        <MenuItem value="-1">Select Country</MenuItem>
        {countries && countries.map(c => <MenuItem key={`country${c.id}`} value={c.id}>
          {c.fullName}
        </MenuItem>)}
      </Select>
      <Select
        key={"stateprovince"}
        disabled={selectedCountryId === -1}
        style={{minWidth:"400px"}}
        value={selectedStateId}
        onChange={async e => {
          if(!lead?.key || !saveLeadData) {
            console.warn("not ready to save lead yet")
            return
          }

          const stateId = Number.parseInt(e.target.value.toString())
          await saveLeadData(lead.key, {
            "country_id": selectedCountryId,
            "state_id": stateId,
          })

          setSelectedStateId(stateId)
        }}
      >
        <MenuItem value="-1">Select {stateOrProvince}</MenuItem>
        {selectedCountryId && states && states.map(s => {
          if(s.countryId.toString() !== selectedCountryId.toString()) {
            return
          }
          return <MenuItem key={`state${s.id}`} value={s.id}>
            {s.fullName}
          </MenuItem>
        })}
      </Select>
    </Typography>
  </>
}